import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'
import Wechat from '@/utils/wechat'
import ua from '@/utils/ua'
import routes from './routes'

Vue.use(VueRouter)

const router = new VueRouter({
  routes: routes.map(route => {
    route.key = route.name
    return route
  }),
  mode: 'history'
})

router.beforeEach((to, from, next) => {
  store.commit('setHistory', to)
  next()
})

router.afterEach(to => {
  if (ua.isWechat) {
    const { name } = to
    let config = {}
    if (name == 'shopLottery' || name == 'lotteryDetail') {
      // new Wechat().init(config).then(wx => {
      //   console.log(wx)
      //   Vue.prototype.$wx = wx
      // })
    }
  }

  store.commit('setTitle', to.meta && to.meta.title)

  // window.scrollTo(0, 0)
})

router.onError(error => {
  console.log('router error', error)
})

export default router
